module.exports = __webpack_public_path__ + "static/img/code.a1964f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/code.png
// module id = 8TFO
// module chunks = 1